import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { formatOrderTypeDisplay } from "~/features/preview/batches/batchSettings.utils";
import { maybePluralize } from "~/lib/helpers";
import { RecurringScheduleDto } from "~/types/api";

type Props = {
  recurringSchedule: RecurringScheduleDto;
};

export function ScheduleOrderCount({ recurringSchedule }: Props) {
  const { t } = useTranslation();
  const { orderType, intervalMinutes, minMaxOrdersPerWave } = recurringSchedule;

  const minToMax = t("{{min}} to {{max}}", {
    min: minMaxOrdersPerWave[0],
    max: minMaxOrdersPerWave[1]
  });
  const displayOrderType = formatOrderTypeDisplay(orderType, t);
  const hasOrderType = displayOrderType.length > 0;
  const numMinutes = intervalMinutes;
  const minuteLabel = t(maybePluralize("minute", numMinutes));

  return (
    <Box sx={{ px: 2, py: 1.5, minWidth: 0 }}>
      <Typography variant="body1">
        {minToMax}
        {hasOrderType ? (
          <>
            {" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              {displayOrderType}
            </Box>
          </>
        ) : null}{" "}
        {t("orders batched every")}{" "}
        <Box component="span" sx={{ fontWeight: 700 }}>
          {numMinutes} {minuteLabel}
        </Box>
      </Typography>
    </Box>
  );
}
